"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureFlag = void 0;
var FeatureFlag = /** @class */ (function () {
    function FeatureFlag() {
        this.fetchIxpFlag = this.fetchIxpFlag.bind(this);
        this.fireABReporting = this.fireABReporting.bind(this);
    }
    FeatureFlag.prototype.fetchIxpFlag = function (response) {
        var _this = this;
        response.then(function (res) {
            if (res && res.status && res.status == 200) {
                if (res.headers) {
                    var ixpFlag = { value: res.headers.get('Ixp-Exp-Flags') };
                    if (ixpFlag && ixpFlag.value && ixpFlag.value !== null) {
                        var ixpHeaders = ixpFlag.value.split('&');
                        ixpHeaders.map(function (item, index) {
                            var ab = item.split('=');
                            var expKey = ab[0];
                            var expValue = ab[1];
                            if ('undefined' !== typeof window && 'undefined' !== typeof window.ddo
                                && 'undefined' !== typeof window.DataMappingInterface) {
                                _this.fireABReporting(expKey, expValue);
                            }
                            else {
                                console.warn("AB Reporting for IXP Flags:: [DMF status= " + window.DataMappingInterface + "]" +
                                    "custom analytics events not activated, so no impression is reported");
                            }
                        });
                        return ixpFlag.value;
                    }
                }
            }
        }).catch(function (e) {
            return Promise.reject(e);
        });
        ;
        return response;
    };
    FeatureFlag.prototype.fireABReporting = function (experimentKey, experimentValue) {
        var addData = {
            abTreatmentName: experimentValue,
            abTestId: experimentKey,
            abCampaignName: '',
            abTestEvent: 'ABTestSplit',
            abSystem: 'IXP',
        };
        window.DataMappingInterface.init({
            additionaldata: addData,
            datatransform: false,
            eventAction: 'impression',
            eventCode: 'impression',
        });
    };
    return FeatureFlag;
}());
exports.FeatureFlag = FeatureFlag;
//# sourceMappingURL=feature-flag.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/networker/lib/feature-flag.js
// module id = 1198
// module chunks = 8